<template>
	<div>

		<egranty-input-field-popup
			:defaultValue="active[0].name"
			:is-open.sync="renamePopupVisible"
			label="Nowa nazwa"
			for="priority-tab-new-name"
			id="priority-tab-new-name"
			title="Zmień nazwę priorytetu"
			long
			@save="rename"
		></egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="addAreaVisible"
			title="Dodaj nowy obszar"
			label="Nazwa obszaru"
			for="priority-tab-name-area"
			id="priority-tab-name-area"
			long
			@save="addArea">
		</egranty-input-field-popup>

		<v-toolbar color="blue">
			<v-toolbar-title>Priorytet ({{active[0].name}})</v-toolbar-title>
		</v-toolbar>
		<v-container style="padding: 12px;">
			<div>
				<v-btn @click="addAreaVisible = true"> Dodaj obszar</v-btn>
				<v-btn v-if="!disableCopyButton" @click="copyAreas(active[0])"> Kopiuj obszary</v-btn>
			</div>
			<div>
				<v-btn v-if="!disablePasteButton" @click="pasteAreas()"> Wklej obszary</v-btn>
				<v-btn v-if="!disablePasteAreaButton" @click="pasteArea()"> Wklej obszar</v-btn>
			</div>
			<div>
				<v-btn @click="copyPriority(active[0])"> Kopiuj priorytet</v-btn>
			</div>
			<div>
				<v-btn
					color="lightred"
					v-if="!disabled"
					@click="deleteArea(active[0].id)"> Usuń
				</v-btn>
				<v-btn @click="putHigher">
					<v-icon color="white">arrow_upward</v-icon>
				</v-btn>
				<v-btn @click="putLower">
					<v-icon color="white">arrow_downward</v-icon>
				</v-btn>
				<v-btn
					v-if="!disabled"
					@click="renamePopupVisible= true"> Zmień nazwę
				</v-btn>
			</div>
		</v-container>
	</div>
</template>
<script>
	import {Task} from "@/api/generated/Task";
	import EgrantyInputFieldPopup from "../../../../genericComponents/EgrantyInputFieldPopup";

	export default {
		name: "PriorityTab",
		components: {EgrantyInputFieldPopup},

		computed: {
			disableCopyButton(){
				return this.active[0].children.length == 0;
			},
			disablePasteButton(){
				if(!this.copiedObject){
					return true;
				}
				if(!this.copiedObject.type || !this.copiedObject.id){
					return true;
				}
				if(this.copiedObject.type != "priority"){
					return true;
				}
				if(this.copiedObject.id == this.active[0].id){
					return true;
				}
				if(!this.copiedObject.onlyChildNodes){
					return true;
				}
				return false;
			},
			disablePasteAreaButton(){
				if(!this.copiedObject){
					return true;
				}
				if(!this.copiedObject.type || !this.copiedObject.id){
					return true;
				}
				if(this.copiedObject.type != "area"){
					return true;
				}
				if(this.copiedObject.id == this.active[0].id){
					return true;
				}
				if(this.copiedObject.onlyChildNodes){
					return true;
				}
				return false;
			}
		},
		methods: {
			addArea(name) {
				Task.putArea(this,
					this.active[0].id,
					name,
					() => {
						this.addAreaVisible = false;
						this.$emit("refresh");
					},
				);

			},

			putHigher() {
				Task.postPriorityHigherInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			putLower() {
				Task.postPriorityLowerInView(
					this,
					this.active[0].id,
					() => this.$emit("refresh"),
				);
			},

			rename(newName) {
				Task.postRenamePriority(
					this,
					this.active[0].id,
					newName,
					() => {
						this.$emit("refresh");
					});
			},

			deleteArea(areaId) {
				Task.deletePriority(this, areaId, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("removalError", errorResponse);
					}
				});
			},

			copyAreas(priority){
				let copiedObject = {
					type: priority.type,
					id: priority.id,
					onlyChildNodes: true
				};
				this.$emit("copyObject",copiedObject);
			},
			copyPriority(priority){
				let copiedObject = {
					type: priority.type,
					id: priority.id,
					onlyChildNodes: false
				};
				this.$emit("copyObject",copiedObject);
			},
			pasteAreas(){
				Task.postCopyPriorityAreas(this, this.active[0].id , this.copiedObject.id, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("copyError", errorResponse);
					}
				});
			},
			pasteArea(){
				Task.postCopyPriorityArea(this, this.active[0].id , this.copiedObject.id, () => {
					this.$emit("refresh");
				}, errorResponse => {
					if (errorResponse.status === "NOT_ACCEPTABLE") {
						this.$emit("copyError", errorResponse);
					}
				});
			}

		},

		data() {
			return {
				renamePopupVisible: false,
				addAreaVisible: false,
			};
		},

		props: {
			active: {},
			disabled: {type: Boolean, default: false},
			copiedObject: {
				type: Object,
				default: function () {
					return {};
				},
			}
		},
	};
</script>
